"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesUsageSummary = void 0;
/* eslint-disable sort-keys */
/* eslint-disable sort-keys-fix/sort-keys-fix */
require("ag-grid-community/dist/styles/ag-grid.css");
require("ag-grid-community/dist/styles/ag-theme-balham.css");
const ag_grid_react_1 = require("ag-grid-react");
const ui_1 = require("client/components/ui");
const sales_usage_summary_header_1 = require("client/modules/reporting/modules/reporting-list/components/report-container/sales-usage-summary/components/sales-usage-summary-header");
const store_1 = require("client/modules/reporting/store");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const no_data_found_1 = require("../no-data-found/no-data-found");
const number_formatter_1 = require("../claim-analytics/number-formatter");
require("./sales-usage-summary.less");
let SalesUsageSummary = class SalesUsageSummary extends React.Component {
    constructor(props) {
        super(props);
        this.onButtonExport = () => {
            const params = {
                fileName: "Sales_Usage_Summary.csv"
            };
            this.storeData.gridApi.exportDataAsCsv(params);
        };
        this.storeData = {
            defaultColDef: {
                enablePivot: true,
                enableRowGroup: true,
                enableValue: true,
                sortable: true,
                resizable: true,
                filter: true,
                comparator(a, b) {
                    if (typeof a === "string") {
                        return a.localeCompare(b);
                    }
                    else {
                        return a > b ? 1 : a < b ? -1 : 0;
                    }
                }
            },
            columnDefs: [
                {
                    headerName: "Name",
                    field: "Name",
                    filter: "agTextColumnFilter"
                },
                {
                    headerName: "NDC",
                    field: "pkgCode",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                },
                {
                    headerName: "Manufacturer",
                    field: "Manufacturer",
                    filter: "agTextColumnFilter"
                },
                {
                    headerName: "Distributor",
                    field: "Distributor",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                },
                {
                    headerName: "Pharmacy Name",
                    field: "Pharmacy Name",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                },
                {
                    headerName: "Total Dist Price",
                    field: "Total Dist Price",
                    filter: "agNumberColumnFilter",
                    type: "numericColumn",
                    cellRenderer: "numberFormatter"
                },
                {
                    headerName: "Total Cost to Company",
                    field: "Total Cost to IMB",
                    filter: "agNumberColumnFilter",
                    type: "numericColumn",
                    cellRenderer: "numberFormatter"
                },
                {
                    headerName: "Total Profit",
                    field: "Total Profit",
                    filter: "agNumberColumnFilter",
                    type: "numericColumn",
                    cellRenderer: "numberFormatter"
                },
                {
                    headerName: "PO Approval Date Range",
                    field: "PO Approval Date Range"
                    // filter: "agDateColumnFilter",
                    // filterParams: {
                    //   comparator: (filterLocalDateAtMidnight: any, cellValue: any) => {
                    //     const dateAsString = cellValue;
                    //     if (dateAsString === null) return -1;
                    //     const dateParts = dateAsString.split("/");
                    //     const cellDate = new Date(
                    //       Number(dateParts[2]),
                    //       Number(dateParts[0]) - 1,
                    //       Number(dateParts[1])
                    //     );
                    //     if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                    //       return 0;
                    //     }
                    //     if (cellDate < filterLocalDateAtMidnight) {
                    //       return -1;
                    //     }
                    //     if (cellDate > filterLocalDateAtMidnight) {
                    //       return 1;
                    //     }
                    //   },
                    //   browserDatePicker: true
                    // }
                }
            ],
            rowData: [],
            multiSortKey: "ctrl",
            floatingFilter: true,
            frameworkComponents: {
                numberFormatter: number_formatter_1.NumberFormatter
            }
        };
    }
    async componentDidMount() {
        if (store_1.reportsStore.editModal) {
            await store_1.reportsStore.loadSalesUsage();
        }
    }
    componentWillUnmount() {
        store_1.reportsStore.salesUsageSummaryData = null;
    }
    render() {
        const storeData = store_1.reportsStore.salesUsageSummaryData;
        this.storeData.rowData = storeData;
        const loadingData = store_1.reportsStore.showLoader;
        if (storeData && storeData.length > 0) {
            return (React.createElement(React.Fragment, null,
                React.createElement(sales_usage_summary_header_1.SalesUsageSummaryHeader, { title: "Sales Usage Summary", withDatePicker: true }),
                React.createElement("div", { className: "ag-theme-balham", style: {
                        height: "85%",
                        width: "100%"
                    } },
                    React.createElement("button", { onClick: this.onButtonExport.bind(this) }, "Export to CSV"),
                    React.createElement(ag_grid_react_1.AgGridReact, { onGridReady: params => (this.storeData.gridApi = params.api), 
                        // rowSelection={this.storeData.rowSelection}
                        columnDefs: this.storeData.columnDefs, defaultColDef: this.storeData.defaultColDef, frameworkComponents: this.storeData.frameworkComponents, multiSortKey: this.storeData.multiSortKey, animateRows: true, sideBar: true, groupMultiAutoColumn: true, floatingFilter: this.storeData.floatingFilter, suppressExcelExport: true, rowData: this.storeData.rowData }))));
        }
        if (storeData) {
            if (loadingData) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(sales_usage_summary_header_1.SalesUsageSummaryHeader, { title: "Sales Usage Summary", withDatePicker: true }),
                    React.createElement("div", null, "Loading Data...")));
            }
            // Return a Custom built component here to handle 0 data returned.
            return (React.createElement(no_data_found_1.default, { headerComponent: React.createElement(sales_usage_summary_header_1.SalesUsageSummaryHeader, { title: "Sales Usage Summary", withDatePicker: true }) }));
        }
        return React.createElement(ui_1.UiLoadingIndicator, null);
    }
};
SalesUsageSummary = __decorate([
    mobx_react_1.observer
], SalesUsageSummary);
exports.SalesUsageSummary = SalesUsageSummary;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/sales-usage-summary/sales-usage-summary.tsx
// module id = 3953
// module chunks = 0